module.exports = __webpack_public_path__ + "img/58.f8fc8e41.jpg";